import { FiTrendingUp, FiMapPin, FiHome, FiDollarSign, FiList } from 'react-icons/fi';
import { LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip } from 'recharts';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useProperties from '../../utils/useProperties';



interface Category {
  name: string;
  icon: JSX.Element;
  value: number;
}
const Dashboard = () => {

  const {properties} = useProperties()
  const [categories, setCategories] = useState<Category[]>([]);
  


  useEffect(() => {
    const groupedCategories = [
      { name: 'Property', icon: <FiHome className="text-green-500 text-2xl" />, value: 0 },
      { name: 'Land', icon: <FiMapPin className="text-blue-500 text-2xl" />, value: 0 },
      { name: 'Rental', icon: <FiDollarSign className="text-yellow-500 text-2xl" />, value: 0 },
      { name: 'Shortlets', icon: <FiTrendingUp className="text-[#c08b53] text-2xl" />, value: 0 },
      { name: 'Sell', icon: <FiDollarSign className="text-purple-500 text-2xl" />, value: 0 },
      { name: 'Enlist', icon: <FiList className="text-pink-500 text-2xl" />, value: 0 },
    ];

    // Count occurrences of each category
    properties?.forEach((property) => {
      const category = groupedCategories.find((cat) => cat.name === property.category);
      if (category) {
        category.value += 1;
      }
    });

    setCategories(groupedCategories);
  }, [properties]); // Only re-run this effect when `properties` changes


  const navigate = useNavigate()
  const totalCount = categories.reduce((acc, category) => acc + category.value, 0);
  const emailStored = localStorage.getItem('akjodem_email');
  const loggedInStored = localStorage.getItem('akjodem_isLoggedIn');
  
  useEffect(() => {
    if (!emailStored && !loggedInStored) {
      navigate('/login');
    }
  }, []);

  return (
    <>
      {loggedInStored &&
        <div className='p-6'>
          <h1 className="mb-6 font-bold text-3xl">Dashboard{emailStored} {loggedInStored}</h1>

          {/* Summary Section */}
          <div className="gap-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 mb-8">
            {categories.map((category) => (
              <div
                key={category.name}
                className="flex flex-col justify-center items-center bg-white shadow-lg hover:shadow-xl p-6 rounded-lg transition-shadow duration-300"
              >
                <div className="bg-gray-100 p-4 rounded-full">{category.icon}</div>
                <h2 className="mt-4 font-medium text-lg">{category.name}</h2>
                <p className="font-bold text-gray-700 text-2xl">{category.value}</p>
              </div>
            ))}
          </div>

          {/* Total Section */}
          <div className="flex justify-between items-center bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 shadow-lg mb-8 p-6 rounded-lg text-white">
            <div>
              <h2 className="font-medium text-xl">Total Listings</h2>
              <p className="font-bold text-4xl">{totalCount}</p>
            </div>
            <div>
              <FiTrendingUp className="opacity-60 text-6xl" />
            </div>
          </div>


        </div>
      }
    </>
  )
};

export default Dashboard;
